import { render, staticRenderFns } from "./trochaldisk-detail.vue?vue&type=template&id=551e89bc&scoped=true&"
import script from "./trochaldisk-detail.vue?vue&type=script&lang=js&"
export * from "./trochaldisk-detail.vue?vue&type=script&lang=js&"
import style0 from "./trochaldisk-detail.vue?vue&type=style&index=0&id=551e89bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e89bc",
  null
  
)

export default component.exports